module.exports = __webpack_public_path__ + "img/logo.d959b9ae.svg";